$bog_music_player $mol_view
	current_key? \
	queue_keys /
	queue_index? 0
	play_track? null
	full false
	cover \
	attr *
		^
		bog_music_player_full <= full
	Empty $mol_view
		sub /
			<= Empty_icon $mol_icon_music
			<= Empty_text $mol_view
				sub / \Ничего не играет
	sub /
		<= Missing $mol_view
			sub /
				<= Missing_text $mol_view
					sub / <= missing \
				<= Missing_pull $mol_button_minor
					title \Перенести
					click? <=> missing_pull? null
		<= Progress_row $mol_view
			sub /
				<= Progress $mol_view
					event *
						pointerdown?event <=> seek_pointer_down?event null
						pointermove?event <=> seek_pointer_move?event null
						pointerup?event <=> seek_pointer_up?event null
						pointercancel?event <=> seek_pointer_up?event null
					sub <= progress_parts /
						<= Progress_line $mol_view
						<= Progress_bar $mol_view
							style *
								width <= progress_width \
						<= Progress_knob $mol_view
							style *
								left <= progress_width \
						<= Trim_start_handle $mol_view
							event *
								pointerdown?event <=> trim_start_pointer_down?event null
								pointermove?event <=> trim_start_pointer_move?event null
								pointerup?event <=> trim_pointer_up?event null
								pointercancel?event <=> trim_pointer_up?event null
							style *
								left <= trim_start_left \
						<= Trim_end_handle $mol_view
							event *
								pointerdown?event <=> trim_end_pointer_down?event null
								pointermove?event <=> trim_end_pointer_move?event null
								pointerup?event <=> trim_pointer_up?event null
								pointercancel?event <=> trim_pointer_up?event null
							style *
								left <= trim_end_left \
		<= Time_row $mol_view
			sub /
				<= Time_current $mol_paragraph
					title <= time_current_text \
				<= Trim_hint $mol_view
					sub / <= trim_hint \
				<= Time_total $mol_paragraph
					title <= time_total_text \
		<= Controls $mol_view
			sub /
				<= Left $mol_view
					event *
						click?event <=> open?event null
					sub /
						<= Cover $mol_image
							uri <= cover
						<= Cover_placeholder $mol_icon_music
						<= Track_info $mol_view
							sub /
								<= Title $mol_paragraph
									title <= title \
								<= Artist $mol_paragraph
									title <= artist \
				<= Center $mol_view
					sub /
						<= Prev $mol_button_minor
							click? <=> prev? null
							sub / <= Prev_icon $mol_icon_skip_previous
						<= Toggle $mol_button_minor
							hint <= toggle_hint \
							click? <=> toggle? null
							sub <= toggle_icons /
								<= Play_icon $mol_icon_play
								<= Pause_icon $mol_icon_pause
						<= Next $mol_button_minor
							click? <=> next? null
							sub / <= Next_icon $mol_icon_skip_next
				<= Options $mol_view
					sub /
						<= Repeat $mol_button_minor
							hint <= repeat_hint \
							click? <=> repeat_cycle? null
							sub /
								<= Repeat_all_icon $mol_icon_repeat
								<= Repeat_one_icon $mol_icon_repeat_once
								<= Shuffle_icon $mol_icon_shuffle
						<= Trim_toggle $mol_check_icon
							hint \Обрезать начало и конец
							Icon <= Trim_icon $mol_icon_content_cut
							checked? <=> trim_mode? false
						<= Eq $mol_pop
							Anchor <= Eq_anchor $mol_button_minor
								hint \Эквалайзер
								click? <=> eq_pop_toggle? null
								sub / <= Eq_icon $mol_icon_tune_vertical
							bubble_content /
								<= Eq_panel $mol_view
									sub /
										<= Eq_curve $bog_music_eq_curve
											gains <= eq_gains /number
											pointer_down?event <=> eq_pointer_down?event null
											pointer_move?event <=> eq_pointer_move?event null
											pointer_up?event <=> eq_pointer_up?event null
										<= Eq_power $mol_check_icon
											title \Эквалайзер
											hint \Включить эквалайзер
											Icon <= Eq_power_icon $mol_icon_tune_vertical
											checked? <=> eq_on? false
										<= Eq_presets $mol_view
											sub <= eq_preset_rows /
												<= Eq_preset_row*0 $mol_check
													title <= eq_preset_title* \
													checked? <=> eq_preset_checked*? false
						<= Volume $mol_pop
							align \top_right
							Anchor <= Volume_anchor $mol_button_minor
								hint \Громкость
								click? <=> volume_toggle? null
								sub / <= Volume_icon $mol_icon_volume_high
							bubble_content /
								<= Volume_panel $mol_view
									sub /
										<= Norm $mol_check_icon
											hint \Выравнивать громкость треков
											Icon <= Norm_icon $mol_icon_equalizer
											checked? <=> normalize? true
										<= Volume_slider $mol_view
											event *
												pointerdown?event <=> volume_pointer_down?event null
												pointermove?event <=> volume_pointer_move?event null
												pointerup?event <=> volume_pointer_up?event null
												pointercancel?event <=> volume_pointer_up?event null
											sub /
												<= Volume_fill $mol_view
													style *
														height <= volume_fill_height \
				<= Collapse $mol_button_minor
					hint \Свернуть плеер
					click? <=> collapse?event null
					sub / <= Collapse_icon $mol_icon_chevron_down
				<= Close $mol_button_minor
					hint \Закрыть плеер
					click? <=> close? null
					sub / <= Close_icon $mol_icon_close
